module.exports = __webpack_public_path__ + "img/1_015.570b0ac9.jpg";